import { Icon, IconProps } from '@elkaso-app/web-design';
import { MdOutlinePointOfSale } from 'react-icons/md';

export const PosIntegrationsIcons = (props: IconProps) => {
  return <Icon as={MdOutlinePointOfSale} width='24px' height='24px' viewBox='0 0 24 24' fill='#757575' {...props} />;
};
